import React, { useState, useEffect } from "react";
import { API_URL } from "../../utils/config";
import { formatDate, formatNumero } from "../../utils/Utilitats";
import { mapejos } from "../../utils/Mapejos";
import AjudaTreball from "./AjudaTreball";
import { BotoAjuda } from "./AjudaModal";
import TeclaEscEnter from "../../utils/Teclaescenter";
import "./treballs.css";
import "../dashboard.css";

function ResumTreball({ treball, onCancel, subnav }) {
  const [resum, setResum] = useState(null);
  const [mostraAjuda, setMostraAjuda] = useState(false);
  const [loading, setLoading] = useState(true);

  TeclaEscEnter(onCancel, null);

  useEffect(() => {
    if (!treball?.idTreballs) return;
    fetchResum();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [treball]);

  const fetchResum = async () => {
    setLoading(true);
    try {
      const resp = await fetch(`${API_URL}/ResumTreball.php`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ idTreballs: treball.idTreballs }),
      });
      const data = await resp.json();
      if (data.success) {
        setResum(data.resum);
      }
    } catch (err) {
      console.error("Error carregant resum:", err);
    }
    setLoading(false);
  };

  if (loading) return <div className="Dashboard-container"><p>Carregant resum...</p></div>;

  const r = resum || {};
  const pendents = r.perEstat?.Pendent || 0;
  const acabades = r.perEstat?.Acabat || 0;
  const urgents = r.perPrioritat?.Urgent || 0;
  const altes = r.perPrioritat?.Alta || 0;

  const exec = r.execucio || {};
  const pctMO = exec.preuTotalHoresEstimat > 0
    ? (exec.valorHoresExecutades / exec.preuTotalHoresEstimat * 100) : 0;
  const pctProd = exec.preuTotalProducteEstimat > 0
    ? (exec.valorProductesExecutats / exec.preuTotalProducteEstimat * 100) : 0;
  const pctGlobal = exec.valorTotal > 0
    ? (exec.valorExecutat / exec.valorTotal * 100) : 0;

  const BarraExecucio = ({ label, percentatge, valorExecutat, valorTotal }) => (
    <div className="treballs-resum-barra">
      <div className="barra-label">
        <strong>{label}</strong>
        <span>{percentatge.toFixed(1)}%</span>
      </div>
      <div className="barra-track">
        <div
          className="barra-fill"
          style={{ width: `${Math.min(percentatge, 100)}%` }}
        />
      </div>
      <div className="barra-valors">
        <span>Executat: {formatNumero(valorExecutat)} €</span>
        <span>Total: {formatNumero(valorTotal)} €</span>
      </div>
    </div>
  );

  return (
    <div className="dv2-entity">
      {mostraAjuda && <AjudaTreball pestanya="resum" onTancar={() => setMostraAjuda(false)} />}
      <div className="dv2-pageHeader">
        <div className="dv2-pageHeader-main">
          <div className="dv2-pageHeader-icon" aria-hidden="true">📊</div>
          <div>
            <h1 className="dv2-pageHeader-title">Resum</h1>
            <p className="dv2-pageHeader-subtitle">
              {treball?.idTreballIntern || treball?.idTreballs}
              {treball?.NomClient ? ` · ${treball.NomClient}` : ""}
              
            </p>
          </div>
        </div>
        <div className="dv2-pageHeader-actions">
          <BotoAjuda title="Com funciona el Resum del Treball" onClick={() => setMostraAjuda(true)} />
          <button type="button" className="dv2-btn" onClick={onCancel}>Tornar</button>
        </div>
      </div>
      {subnav}
      <div className="dv2-entity-body">

      <div className="Dashboard-form-row" style={{ marginBottom: 12 }}>
        <div className="info-inline"><strong>Estat:</strong> {treball?.Estat || "—"}</div>
        <div className="info-inline"><strong>Tipus:</strong> {mapejos.tipusTreballMap[treball?.TipusTreball] || treball?.TipusTreball || "—"}</div>
        <div className="info-inline"><strong>Prioritat:</strong> {treball?.PrioritatTreball || "—"}</div>
        <div className="info-inline"><strong>Data Alta:</strong> {formatDate(treball?.DataAlta)}</div>
      </div>

      {/* KPIs */}
      <div className="treballs-resum-grid">
        <div className="treballs-resum-kpi">
          <div className="kpi-value">{r.totalTasques || 0}</div>
          <div className="kpi-label">Total Tasques</div>
        </div>
        <div className={`treballs-resum-kpi ${pendents > 0 ? "" : "kpi-success"}`}>
          <div className="kpi-value">{pendents}</div>
          <div className="kpi-label">Pendents</div>
        </div>
        <div className="treballs-resum-kpi kpi-success">
          <div className="kpi-value">{acabades}</div>
          <div className="kpi-label">Acabades</div>
        </div>
        <div className="treballs-resum-kpi">
          <div className="kpi-value">{r.totalAgrupacions || 0}</div>
          <div className="kpi-label">Agrupacions</div>
        </div>
        <div className={`treballs-resum-kpi ${r.tasquesSenseAgrupacio > 0 ? "kpi-warning" : ""}`}>
          <div className="kpi-value">{r.tasquesSenseAgrupacio || 0}</div>
          <div className="kpi-label">Sense Agrupació</div>
        </div>
        <div className="treballs-resum-kpi">
          <div className="kpi-value">{r.totalDependencies || 0}</div>
          <div className="kpi-label">Dependències</div>
        </div>
        {urgents > 0 && (
          <div className="treballs-resum-kpi kpi-warning">
            <div className="kpi-value">{urgents}</div>
            <div className="kpi-label">Urgents</div>
          </div>
        )}
        {altes > 0 && (
          <div className="treballs-resum-kpi">
            <div className="kpi-value">{altes}</div>
            <div className="kpi-label">Prioritat Alta</div>
          </div>
        )}
      </div>

      {/* Barres d'execució */}
      <div className="treballs-resum-execucio">
        <h4>Execució del treball</h4>
        <BarraExecucio
          label="Mà d'Obra"
          percentatge={pctMO}
          valorExecutat={exec.valorHoresExecutades || 0}
          valorTotal={exec.preuTotalHoresEstimat || 0}
        />
        <BarraExecucio
          label="Productes"
          percentatge={pctProd}
          valorExecutat={exec.valorProductesExecutats || 0}
          valorTotal={exec.preuTotalProducteEstimat || 0}
        />
        <BarraExecucio
          label="Global"
          percentatge={pctGlobal}
          valorExecutat={exec.valorExecutat || 0}
          valorTotal={exec.valorTotal || 0}
        />
      </div>

      </div>
    </div>
  );
}

export default ResumTreball;
